  window.addEventListener("DOMContentLoaded", (event) => {
    var PRODUCT_ATC_SELECTOR = ".js-product-atc-btn";
    function queryAllProductAtcButtons() {
      return document.querySelectorAll(PRODUCT_ATC_SELECTOR);
    }
    function getPrimaryProductAtcButton() {
      var list = queryAllProductAtcButtons();
      return list.length ? list[0] : null;
    }
    function getActiveOnloadNotifyContainer() {
      var nodes = document.querySelectorAll(".js-onload-notify");
      if (!nodes.length) return null;
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var cs = window.getComputedStyle(el);
        if (cs.display === "none" || cs.visibility === "hidden") continue;
        var r = el.getBoundingClientRect();
        if (r.width < 2 && r.height < 2) continue;
        return el;
      }
      return nodes[0];
    }

    /** PW Stock Notify trigger (id is stable; app may nest under shopify-block-*). */
    let __cachedNotifyButton = null;
    function findNotifyTriggerButton() {
      var el = document.getElementById("pw_notify_popup_open");
      if (el) {
        __cachedNotifyButton = el;
        return el;
      }
      var blocks = document.querySelectorAll('[id^="shopify-block-pw_stock_notify_app_block_"]');
      for (var i = 0; i < blocks.length; i++) {
        el = blocks[i].querySelector("#pw_notify_popup_open");
        if (el) {
          __cachedNotifyButton = el;
          return el;
        }
      }
      var form = document.getElementById("AddToCartForm");
      if (form) {
        el = form.querySelector("#pw_notify_popup_open");
        if (el) {
          __cachedNotifyButton = el;
          return el;
        }
      }
      if (__cachedNotifyButton) return __cachedNotifyButton;
      return null;
    }

    /**
     * Mount notify next to the main buy buttons. Do not rely on visibility/size heuristics — those
     * could skip the desktop wrapper and land in the "missing container" branch (sold out never hides).
     */
    function getNotifyMountContainer() {
      var mainAtc =
        document.querySelector("#AddToCart--main.js-product-atc-btn") ||
        document.querySelector("#AddToCart--main");
      if (mainAtc) {
        var wrap = mainAtc.closest(".js-onload-notify");
        if (wrap) return wrap;
        wrap = mainAtc.closest(".paymentButtonsWrapper");
        if (wrap) {
          wrap.classList.add("js-onload-notify");
          return wrap;
        }
      }
      return getActiveOnloadNotifyContainer();
    }

    function markProductFormVueReady() {
      var el = document.querySelector("wetheme-product-form");
      if (!el) return false;
      if (el.__vue__) {
        el.classList.add("product-form--ready");
        return true;
      }
      return false;
    }
    if (!markProductFormVueReady()) {
      var _vueReadyTries = 0;
      var _vueReadyTimer = setInterval(function () {
        if (markProductFormVueReady() || ++_vueReadyTries > 120) clearInterval(_vueReadyTimer);
      }, 50);
    }
    document.addEventListener("shopify:section:load", function () {
      var wf = document.querySelector("wetheme-product-form");
      if (wf) wf.classList.remove("product-form--ready");
      setTimeout(function () {
        var n = 0;
        var t2 = setInterval(function () {
          if (markProductFormVueReady() || ++n > 80) clearInterval(t2);
        }, 50);
      }, 30);
    });

    // add to cart mobile
    let mobileAtc = document.querySelector(".atc--mobile");
    let qtyBox = document.querySelector(".qty-mobile");
    let mobileInput = document.querySelector("#Quantity-mobile");

    qtyBox?.addEventListener("click", function (e) {
      let plus = e.target.closest(".qty-mobile .js-qty__adjust--plus-mobile");
      if (!plus) return;
      mobileInput.value = Number(mobileInput.value) + 1;
    });
    qtyBox?.addEventListener("click", function (e) {
      let minus = e.target.closest(".qty-mobile .js-qty__adjust--minus-mobile");
      if (!minus) return;
      mobileInput.value =
        Number(mobileInput.value) != 1 ? Number(mobileInput.value) - 1 : 1;
    });

    mobileAtc?.addEventListener("click", function () {
      let qty = mobileInput.value;
      let variantSelected = document.querySelector("form select").value;

      let formData = {
        items: [
          {
            quantity: qty,
            id: variantSelected,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          this.textContent = "adding...";
          return response.ok ? response.json() : response.json().then((err) => { throw err; });
        })
        .then((data) => {
          this.textContent = "Added to cart";
          setTimeout(function () {
            mobileAtc.textContent = "Add to cart";
          }, 2000);
          if (window.trackAddToCart && data && data.id) {
            window.trackAddToCart(data.id, data.quantity || parseInt(qty, 10) || 1, {
              product_id: data.product_id,
              product_title: data.product_title,
              variant_title: data.variant_title,
              price: (data.price || 0) / 100,
              value: (data.price || 0) / 100,
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD"
            });
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
        })
        .catch((error) => console.log(error));
    });

    // slide arrow – single source of truth: bullets or thumbnails (both trigger same media activation)
    // Re-query imageWarpper each time (Vue may mount after DOMContentLoaded)
    function getImageWrapper() {
      return document.querySelector(".images-product-wrapper");
    }
    let imageWarpper = getImageWrapper();
    let zoomimg = document.querySelector(".products-images img:first-child");
    var _gallerySyncFn = function () {};

    function syncGalleryHeight() {
      var wrapper = getImageWrapper();
      if (!wrapper) return;
      const container = wrapper.querySelector(".product-medias__main .swiper-container");
      if (!container) return;
      const activeSlide =
        wrapper.querySelector(".swiper-slide.product-medias__primary") ||
        wrapper.querySelector(".product-medias__main .swiper-slide");
      if (!activeSlide) return;
      let h = activeSlide.offsetHeight;
      if (h <= 0) {
        const img = activeSlide.querySelector("img");
        if (img && img.naturalHeight) h = img.naturalHeight;
      }
      if (h > 0) container.style.height = h + "px";
    }

    function bindGalleryImageLoad() {
      var wrapper = getImageWrapper();
      if (!wrapper) return;
      wrapper.querySelectorAll(".product-medias__main img").forEach(function (img) {
        if (img.dataset.heightBound) return;
        img.dataset.heightBound = "1";
        if (img.complete) syncGalleryHeight();
        else img.addEventListener("load", syncGalleryHeight, { once: true });
      });
    }

    function runGallerySync() {
      syncGalleryHeight();
      bindGalleryImageLoad();
    }
    if (getImageWrapper()) _gallerySyncFn = runGallerySync;

    // PDP thumbnail click fallback: always register (so it works even if .images-product-wrapper is missing at DOMContentLoaded)
    var thumbSelector = ".product-medias__thumbnail, .product_medias_thumbnail, .product-medias.thumbnail, a[href='#'][data-media-id], a[data-media-id].product-medias, a[data-media-id]";
    function activateProductMediaByThumb(thumb) {
      var wrapper = thumb.closest(".images-product-wrapper") || thumb.closest(".product-single") || thumb.closest(".product-form-vue") || thumb.closest(".product-images-container");
      if (!wrapper) return false;
      var thumbnails = wrapper.querySelectorAll(thumbSelector);
      var slides = wrapper.querySelectorAll(".product-medias__main .swiper-slide, .swiper-container .swiper-slide");
      var mediaId = thumb.getAttribute("data-media-id");
      var thumbIndex = Array.from(thumbnails).indexOf(thumb);
      if (thumbIndex < 0) return false;

      var slideIndex = -1;
      if (mediaId && slides.length > 0) {
        for (var i = 0; i < slides.length; i++) {
          var el = slides[i];
          if (el.getAttribute("data-media-id") === mediaId || el.querySelector("[data-media-id='" + mediaId + "']")) {
            slideIndex = i;
            break;
          }
        }
      }
      
      if (slideIndex < 0) {
        slideIndex = thumbIndex;
      }

      if (slides.length > 0) {
        if (slideIndex >= slides.length) return false;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("product-medias__primary", i === slideIndex);
        });
        var container = wrapper.querySelector(".product-medias__main .swiper-container, .swiper-container");
        if (container && typeof container.swiper !== "undefined" && typeof container.swiper.slideTo === "function") {
          container.swiper.slideTo(slideIndex);
        }
      } else if (mediaId) {
        var mediaItems = wrapper.querySelectorAll(".product-medias__main [data-media-id], .swiper-slide [data-media-id], .product-medias__media[data-media-id]");
        mediaItems.forEach(function (el) {
          var active = el.getAttribute("data-media-id") === mediaId;
          el.classList.toggle("product-medias__primary", active);
          el.classList.toggle("product-medias__media--active", active);
          var slide = el.closest(".swiper-slide");
          if (slide) slide.classList.toggle("product-medias__primary", active);
        });
      } else {
        return false;
      }
      thumbnails.forEach(function (t, i) {
        t.classList.toggle("product-single_media--selected", i === thumbIndex);
      });
      setTimeout(_gallerySyncFn, 50);
      return true;
    }
    function onThumbClick(e) {
      var thumb = e.target.closest(thumbSelector);
      if (!thumb) return;
      if (activateProductMediaByThumb(thumb)) {
        e.preventDefault();
      }
    }
    function onThumbKeydown(e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var thumb = e.target.closest(thumbSelector);
      if (!thumb) return;
      if (activateProductMediaByThumb(thumb)) {
        e.preventDefault();
      }
    }
    document.addEventListener("click", onThumbClick, true);
    document.addEventListener("keydown", onThumbKeydown, true);

    // Expose for inline script in product-media.liquid (direct thumbnail handlers)
    window.__activateProductMediaByThumb = activateProductMediaByThumb;

    function bindThumbnailsDirect() {
      document.querySelectorAll('.product-images-container a[data-media-id]:not([data-pdp-thumb-bound])').forEach(function(a) {
        a.setAttribute('data-pdp-thumb-bound', '1');
        a.addEventListener('click', function(e) {
          e.preventDefault();
          activateProductMediaByThumb(a);
        });
        a.addEventListener('keydown', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          activateProductMediaByThumb(a);
        });
      });
    }
    bindThumbnailsDirect();
    window.addEventListener('load', bindThumbnailsDirect);

    function navigateGallery(direction) {
      var wrapper = getImageWrapper();
      if (!wrapper) return;
      
      // First, try swiper native navigation if available
      var container = wrapper.querySelector(".product-medias__main .swiper-container, .swiper-container");
      if (container && typeof container.swiper !== "undefined") {
        if (typeof container.swiper.slideNext === "function" && typeof container.swiper.slidePrev === "function") {
          if (direction === "next") {
            container.swiper.slideNext();
          } else {
            container.swiper.slidePrev();
          }
          setTimeout(syncGalleryHeight, 150);
          return;
        }
      }

      const bullets = wrapper.querySelectorAll(".swiper-pagination-bullet");
      const thumbnails = wrapper.querySelectorAll(thumbSelector);
      const slides = wrapper.querySelectorAll(".swiper-slide");
      
      // Fallback: If no swiper instance, use bullets or thumbnails directly
      const validNavigables = bullets.length ? bullets : thumbnails;
      const total = validNavigables.length;
      
      if (total <= 1) return;

      let currentIndex = -1;

      const activeBullet = wrapper.querySelector(".swiper-pagination-bullet-active");
      if (activeBullet && bullets.length) {
        currentIndex = Array.from(bullets).indexOf(activeBullet);
      }
      if (currentIndex < 0) {
        const activeSlide = wrapper.querySelector(".swiper-slide.product-medias__primary");
        if (activeSlide && slides.length) {
          currentIndex = Array.from(slides).indexOf(activeSlide);
        }
        
        // If we fall back to slide index, we need to map it back to the thumbnail/bullet index
        if (currentIndex >= 0 && validNavigables === thumbnails) {
          var activeSlideEl = slides[currentIndex];
          var mediaId = activeSlideEl.querySelector("[data-media-id]") ? activeSlideEl.querySelector("[data-media-id]").getAttribute("data-media-id") : null;
          if (mediaId && mediaId !== "") {
            for (var i = 0; i < thumbnails.length; i++) {
              if (thumbnails[i].getAttribute("data-media-id") === mediaId) {
                currentIndex = i;
                break;
              }
            }
          } else {
            // fallback index bounding
            currentIndex = Math.min(currentIndex, total - 1);
          }
        }
      }
      if (currentIndex < 0) currentIndex = 0;
      // ensure within range
      currentIndex = Math.min(currentIndex, total - 1);

      const targetIndex = direction === "next"
        ? (currentIndex + 1) % total
        : (currentIndex - 1 + total) % total;

      if (validNavigables[targetIndex]) {
        validNavigables[targetIndex].click();
      }
      setTimeout(syncGalleryHeight, 150);
    }

    function initProductGallery() {
      var wrapper = getImageWrapper();
      if (!wrapper) return;
      if (wrapper.dataset.galleryHandlersAttached === "1") return;
      wrapper.dataset.galleryHandlersAttached = "1";

      wrapper.addEventListener("click", function (e) {
        if (e.target.closest(".flex-next")) {
          e.preventDefault();
          navigateGallery("next");
        }
      });
      wrapper.addEventListener("click", function (e) {
        if (e.target.closest(".flex-prev")) {
          e.preventDefault();
          navigateGallery("prev");
        }
      });
      wrapper.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        if (e.target.closest(".flex-next")) {
          e.preventDefault();
          navigateGallery("next");
        } else if (e.target.closest(".flex-prev")) {
          e.preventDefault();
          navigateGallery("prev");
        }
      });
      wrapper.addEventListener("click", function (e) {
        let zoom = e.target.closest(".imzoom");
        if (!zoom) return;
        if (zoomimg) zoomimg.click();
      });

      wrapper.addEventListener("click", onThumbClick);
      wrapper.addEventListener("keydown", onThumbKeydown);

      runGallerySync();
      [100, 200, 400, 800].forEach(function (ms) {
        setTimeout(runGallerySync, ms);
      });
      let heightSyncTimer = 0;
      const main = wrapper.querySelector(".product-medias__main");
      if (main) {
        const heightObs = new MutationObserver(function () {
          if (heightSyncTimer) clearTimeout(heightSyncTimer);
          heightSyncTimer = setTimeout(function () {
            heightSyncTimer = 0;
            runGallerySync();
          }, 100);
        });
        heightObs.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
      }
    }

    initProductGallery();
    window.addEventListener("load", function () {
      runGallerySync();
      initProductGallery();
    });
    var galleryRetryCount = 0;
    var galleryRetryInterval = setInterval(function () {
      galleryRetryCount++;
      if (galleryRetryCount > 25) {
        clearInterval(galleryRetryInterval);
        return;
      }
      var wrapper = getImageWrapper();
      if (wrapper && wrapper.querySelectorAll(".swiper-slide").length > 0) {
        clearInterval(galleryRetryInterval);
        runGallerySync();
      }
    }, 200);

    // sku code
    const swatchEl = document.querySelectorAll(".swatch-element");
    const allSku = document.querySelectorAll(".all-skus");
    const allSkuname = document.querySelectorAll(".sku-name");
    let swatchWrapper = document.querySelector(".swatch-items-wrapper");
    let getthnotify = document.querySelector(
      '[id^="shopify-block-pw_stock_notify_app_block_"]'
    );
    let swatchWrappergrp = document.querySelector(
      ".swatch-items-wrapper .swatch-element input:checked"
    );
    let paymentButtonsWrapperonload = document.querySelector(".form-vertical");
    // console.log(paymentButtonsWrapperonload,'paymentButtonsWrapperonload')
    let getaddtocart = getPrimaryProductAtcButton();
    var onloadnotifyDiv = getActiveOnloadNotifyContainer();
    let notifyButton = findNotifyTriggerButton();

    const DEBUG_LOG_ENDPOINT =
      "http://127.0.0.1:7242/ingest/863e0970-f23e-49a5-8b5e-e384559fb0de";
    const DEBUG_LOGS_ENABLED = ["localhost", "127.0.0.1"].includes(
      window.location.hostname
    );
    function sendDebugLog(payload) {
      if (!DEBUG_LOGS_ENABLED) return;
      fetch(DEBUG_LOG_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).catch(() => {});
    }

    // Utility: toggle visibility for all Add to Cart buttons (desktop + mobile)
    function setAddToCartVisibility(show) {
      const atcButtons = queryAllProductAtcButtons();
      const notifyButtons = document.querySelectorAll("#pw_notify_popup_open");
      atcButtons.forEach((btn) => {
        if (!btn) return;
        if (show) {
          btn.style.setProperty("display", "", "important");
          btn.style.setProperty("visibility", "", "important");
          btn.style.setProperty("opacity", "", "important");
          btn.style.setProperty("position", "", "important");
          btn.style.setProperty("pointer-events", "", "important");
          btn.style.setProperty("z-index", "", "important");
          btn.style.setProperty("width", "", "important");
          btn.style.setProperty("margin", "", "important");
          btn.removeAttribute("aria-hidden");
        } else {
          btn.style.setProperty("display", "none", "important");
          btn.style.setProperty("pointer-events", "none", "important");
          btn.style.setProperty("position", "absolute", "important");
          btn.style.setProperty("visibility", "hidden", "important");
          btn.style.setProperty("opacity", "0", "important");
          btn.style.setProperty("z-index", "-1", "important");
          btn.setAttribute("aria-hidden", "true");
        }
      });
      // When showing Add to Cart, ensure notify is fully hidden and non-interactive
      if (show && notifyButtons.length) {
        notifyButtons.forEach((btn) => {
          btn.style.setProperty("display", "none", "important");
          btn.style.setProperty("visibility", "hidden", "important");
          btn.style.setProperty("opacity", "0", "important");
          btn.style.setProperty("position", "absolute", "important");
          btn.style.setProperty("pointer-events", "none", "important");
          btn.style.setProperty("z-index", "-1", "important");
          btn.style.setProperty("width", "0", "important");
          btn.style.setProperty("height", "0", "important");
          btn.style.setProperty("padding", "0", "important");
          btn.style.setProperty("margin", "0", "important");
          btn.setAttribute("aria-hidden", "true");
          btn.classList.add("hidden-notify-button");
        });
      }
    }

    function getSelectedVariantOption() {
      return document.querySelector(".product-single__variants option:checked");
    }

    /** Matches WeTheme: product JSON in template — availability does not depend on Vue v-if timing or hidden ATC. */
    function getSelectedVariantAvailableFromProductJson() {
      const el = document.querySelector('script.product-json[type="application/json"]');
      const select = document.querySelector(".product-single__variants");
      if (!el || !select || !select.options || !select.options.length) return null;
      let product;
      try {
        product = JSON.parse(el.textContent);
      } catch (_) {
        return null;
      }
      if (!product || !Array.isArray(product.variants)) return null;
      let vid = parseInt(String(select.value), 10);
      if (!vid) {
        const opt = select.querySelector("option:checked");
        if (opt) vid = parseInt(String(opt.value), 10);
      }
      if (!vid) return null;
      const v = product.variants.find(function (x) {
        return Number(x.id) === vid;
      });
      if (!v || typeof v.available === "undefined") return null;
      return v.available === true;
    }

    function getSwatchOutOfStockState() {
      const checkedInputs = document.querySelectorAll(".swatch-element input:checked");
      if (!checkedInputs.length) return null;
      let isSoldOut = false;
      for (let i = 0; i < checkedInputs.length; i++) {
        const swatchElement = checkedInputs[i].closest(".swatch-element");
        if (swatchElement) {
          if (swatchElement.classList.contains("soldout")) isSoldOut = true;
          if (swatchElement.getAttribute("data-status") === "false") isSoldOut = true;
        }
      }
      return isSoldOut;
    }

    /**
     * Read ATC stock from DOM for every .js-product-atc-btn, including when our notify script
     * has set display:none — otherwise we misread "in stock" from the <select> and flip-flop,
     * leaving a blank buy area while Vue updates.
     * Prefer "unavailable" if any button disagrees (notify safer than hiding both CTAs).
     */
    function getAggregatedAtcDomStockState() {
      const atcButtons = queryAllProductAtcButtons();
      if (!atcButtons.length) return "unknown";

      let sawAvailable = false;
      let sawUnavailable = false;

      for (const atc of atcButtons) {
        if (atc.querySelector(".fa-spin, .fa-circle-o-notch.fa-spin")) {
          continue;
        }
        if (atc.querySelector(".soldoutbtn")) {
          sawUnavailable = true;
          continue;
        }
        const text = (atc.textContent || "").trim().toLowerCase();
        const isSoldOut =
          text.includes("sold out") ||
          text.includes("out of stock") ||
          text.includes("unavailable");
        const isDisabled = atc.disabled || atc.classList.contains("disabled");

        if (isSoldOut || isDisabled) {
          sawUnavailable = true;
          continue;
        }

        if (text.length > 0) {
          sawAvailable = true;
        }
      }

      if (sawUnavailable) return "unavailable";
      if (sawAvailable) return "available";
      return "unknown";
    }

    // Resolve stock: Liquid/JSON variant data first, then DOM (Vue can lag behind late listeners).
    function resolveOutOfStockState() {
      const selectedVariantOption = getSelectedVariantOption();
      const swatchOutOfStock = getSwatchOutOfStockState();
      const atcDom = getAggregatedAtcDomStockState();
      const jsonAvailable = getSelectedVariantAvailableFromProductJson();

      if (selectedVariantOption && selectedVariantOption.disabled) return true;
      if (jsonAvailable === false) return true;
      if (swatchOutOfStock === true) return true;

      if (atcDom === "unavailable") return true;
      if (atcDom === "available") return false;

      if (jsonAvailable === true) return false;

      if (selectedVariantOption && !selectedVariantOption.disabled) return false;
      if (swatchOutOfStock === false) return false;

      return true;
    }

    // Immediately hide notify button on discovery to prevent flash
    function hideNotifyButtonImmediately(button) {
      if (!button) return;
      button.classList.add('hidden-notify-button');
      button.style.display = "none";
      button.style.visibility = "hidden";
      button.style.opacity = "0";
      button.style.position = "absolute";
      button.style.pointerEvents = "none";
      button.style.zIndex = "-1";
      button.style.width = "0";
      button.style.height = "0";
      button.style.padding = "0";
      button.style.margin = "0";
      button.style.overflow = "hidden";
      button.setAttribute('aria-hidden', 'true');
    }

    // Hide button immediately if it exists on page load
    if (notifyButton) {
      hideNotifyButtonImmediately(notifyButton);
    }

    // Function to attach click handler to notify button
    function attachNotifyButtonClickHandler(button) {
      if (!button) return button;

      // #region agent log
      sendDebugLog({ location: 'product-custom.js:134', message: 'attachNotifyButtonClickHandler called', data: { buttonId: button.id, buttonExists: !!button, hasHandler: button.hasAttribute('data-click-handler-attached') }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run2', hypothesisId: 'H' });
      // #endregion

      // If handler already attached, don't re-attach (prevents infinite loop)
      if (button.hasAttribute('data-click-handler-attached')) {
        return button;
      }

      // Attach click handler directly (no cloning to preserve element and prevent loop)
      button.addEventListener('click', function (e) {
        // #region agent log
        sendDebugLog({ location: 'product-custom.js:143', message: 'Notify button clicked', data: { buttonId: this.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run2', hypothesisId: 'H' });
        // #endregion
        e.preventDefault();
        // Don't stopPropagation - app may use event delegation on a parent to create/show popup
        // Match main-backup: mypw_model_popup. Also try iframe (GemPages may render app block in iframe)
        let popup = document.getElementById('mypw_model_popup');
        if (!popup) {
          const iframes = document.querySelectorAll('iframe');
          for (let i = 0; i < iframes.length; i++) {
            try {
              const doc = iframes[i].contentDocument;
              if (doc && (popup = doc.getElementById('mypw_model_popup'))) break;
            } catch (_) {}
          }
        }
        if (!popup) popup = document.getElementById('pw_model_popup') || document.querySelector('[id*="pw_model_popup"]');
        // #region agent log
        sendDebugLog({ location: 'product-custom.js:146', message: 'Popup check after click', data: { popupExists: !!popup, popupId: popup?.id, popupDisplay: popup?.style?.display }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run2', hypothesisId: 'I' });
        // #endregion
        if (popup) {
          popup.style.display = 'flex';
          popup.style.visibility = 'visible';
        } else {
          // App may create popup asynchronously; retry after short delay
          setTimeout(function () {
            const retryPopup = document.getElementById('mypw_model_popup') || document.getElementById('pw_model_popup');
            if (retryPopup) {
              retryPopup.style.display = 'flex';
              retryPopup.style.visibility = 'visible';
            }
          }, 100);
        }
      }, { once: false, passive: false });

      button.setAttribute('data-click-handler-attached', 'true');

      // #region agent log
      sendDebugLog({ location: 'product-custom.js:152', message: 'Click handler attached', data: { buttonId: button.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run2', hypothesisId: 'H' });
      // #endregion

      return button;
    }

    // Track retry attempts for app button
    let notifyButtonRetryCount = 0;
    const MAX_RETRIES = 20; // Try for up to 10 seconds (20 * 500ms)

    /** Collapse many rapid stock checks (form change, observer, load) into one pass to reduce flicker. */
    let notifyUpdateDebounceTimer = null;
    const NOTIFY_UPDATE_DEBOUNCE_MS = 100;
    function scheduleNotifyUpdateImmediate() {
      if (notifyUpdateDebounceTimer) clearTimeout(notifyUpdateDebounceTimer);
      notifyUpdateDebounceTimer = null;
      checkAndUpdateNotifyButton();
    }
    function scheduleNotifyUpdate() {
      if (notifyUpdateDebounceTimer) clearTimeout(notifyUpdateDebounceTimer);
      notifyUpdateDebounceTimer = setTimeout(function () {
        notifyUpdateDebounceTimer = null;
        checkAndUpdateNotifyButton();
      }, NOTIFY_UPDATE_DEBOUNCE_MS);
    }

    // Function to toggle buttons based on stock status
    function toggleButtonsForStock(isOutOfStock) {
      // Re-query elements in case they've changed
      notifyButton = findNotifyTriggerButton();
      
      // Hide native out-of-stock form - we only want app button
      const nativeOutOfStockForm = document.querySelector(".out-of-stock-form");
      if (nativeOutOfStockForm) {
        nativeOutOfStockForm.style.display = "none";
        nativeOutOfStockForm.style.visibility = "hidden";
      }

      if (isOutOfStock) {
        document.body.classList.add('notify-active');
        
        // Hide all add to cart buttons (desktop + mobile)
        setAddToCartVisibility(false);

        if (notifyButton) {
          // Remove hidden class to show the button natively within its App Block
          notifyButton.classList.remove('hidden-notify-button');
          
          // Revert any inline styles that might be hiding it
          notifyButton.style.setProperty('display', 'inline-block', 'important');
          notifyButton.style.setProperty('visibility', 'visible', 'important');
          notifyButton.style.setProperty('opacity', '1', 'important');
          notifyButton.style.setProperty('z-index', '10', 'important');
          notifyButton.style.setProperty('pointer-events', 'auto', 'important');
          notifyButton.style.setProperty('position', 'relative', 'important');
          
          // Remove any inline dimensions that squashed it
          notifyButton.style.removeProperty('width');
          notifyButton.style.removeProperty('height');
          notifyButton.style.removeProperty('padding');
          notifyButton.style.removeProperty('margin');
          notifyButton.style.removeProperty('overflow');
          
          notifyButton.removeAttribute('aria-hidden');
          notifyButtonRetryCount = 0;
        } else {
          // Keep retrying if button is still loading from third-party app
          if (notifyButtonRetryCount < MAX_RETRIES) {
            notifyButtonRetryCount++;
            setTimeout(function () {
              toggleButtonsForStock(true);
            }, 500);
          } else {
            // Give up and show default cart button as fallback
            document.body.classList.remove("notify-active");
            setAddToCartVisibility(true);
            notifyButtonRetryCount = 0;
          }
        }
      } else {
        document.body.classList.remove('notify-active');
        
        // In stock - show add to cart buttons
        setAddToCartVisibility(true);
        
        // Hide ALL notify buttons 
        const allNotifyButtons = document.querySelectorAll("#pw_notify_popup_open, [id^='shopify-block-pw_stock_notify_app_block_'] #pw_notify_popup_open");
        allNotifyButtons.forEach(function (btn) {
          btn.classList.add('hidden-notify-button');
          btn.style.display = "none";
          btn.style.visibility = "hidden";
          btn.style.opacity = "0";
          btn.style.position = "absolute";
          btn.style.pointerEvents = "none";
          btn.style.zIndex = "-1";
          btn.style.width = "0";
          btn.style.height = "0";
          btn.style.padding = "0";
          btn.style.margin = "0";
          btn.style.overflow = "hidden";
          btn.setAttribute('aria-hidden', 'true');
        });
        
        notifyButtonRetryCount = 0;
      }
    }

    // Function to check and update button visibility based on current variant
    function checkAndUpdateNotifyButton() {
      // #region agent log
      sendDebugLog({ location: 'product-custom.js:272', message: 'checkAndUpdateNotifyButton called', data: {}, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'E' });
      // #endregion
      // Mark body as ready after first stock check - allows CSS to show button if needed
      if (!document.body.classList.contains('notify-ready')) {
        document.body.classList.add('notify-ready');
      }

      const isOutOfStock = resolveOutOfStockState();
      const currentSwatch = document.querySelector(".swatch-element input:checked");
      const swatchElement = currentSwatch?.closest(".swatch-element");

      // #region agent log
      sendDebugLog({
        location: 'product-custom.js:294',
        message: 'Resolved stock state',
        data: {
          isOutOfStock: isOutOfStock,
          selectedVariantDisabled: !!getSelectedVariantOption()?.disabled,
          swatchClasses: swatchElement?.className || null
        },
        timestamp: Date.now(),
        sessionId: 'debug-session',
        runId: 'run1',
        hypothesisId: 'A,E'
      });
      // #endregion

      // Toggle body class
      if (isOutOfStock) {
        document.body.classList.add('notify-active');
      } else {
        document.body.classList.remove('notify-active');
      }

      // TOGGLE BUTTON VISIBILITY
      toggleButtonsForStock(isOutOfStock);

      // Hide native out-of-stock form - we only want app button
      const nativeOutOfStockForm = document.querySelector(".out-of-stock-form");
      if (nativeOutOfStockForm) {
        nativeOutOfStockForm.style.display = "none";
        nativeOutOfStockForm.style.visibility = "hidden";
      }
    }

    function scheduleNotifyCheckAfterVariantChange() {
      scheduleNotifyUpdate();
      setTimeout(scheduleNotifyUpdate, 300);
      setTimeout(scheduleNotifyUpdate, 600);
      setTimeout(scheduleNotifyUpdate, 1000);
      setTimeout(scheduleNotifyUpdate, 1500);
    }
    ["variant:changed", "variant:change"].forEach(function (evtName) {
      document.addEventListener(evtName, scheduleNotifyCheckAfterVariantChange, { passive: true });
    });
    const variantSelectForNotify = document.querySelector(".product-single__variants");
    if (variantSelectForNotify) {
      variantSelectForNotify.addEventListener("change", scheduleNotifyCheckAfterVariantChange, { passive: true });
    }
    // WeTheme: onVariantChange() dispatches a native "change" on #AddToCartForm inside $nextTick after Vue
    // updates option1–3 / v-model — not the same as a select-only change when swatches drive state.
    const addToCartFormForNotify = document.querySelector("#AddToCartForm");
    if (addToCartFormForNotify) {
      addToCartFormForNotify.addEventListener("change", scheduleNotifyCheckAfterVariantChange, { passive: true });
    }

    // MutationObserver to watch for button being re-added by third-party app
    const notifyButtonObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is the notify button or contains it
              if (node.id === 'pw_notify_popup_open') {
                // #region agent log
                sendDebugLog({ location: 'product-custom.js:302', message: 'MutationObserver: notify button detected', data: { nodeId: node.id, parentId: node.parentNode?.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' });
                // #endregion
                // Check stock status BEFORE hiding - only hide if in stock
                const isOutOfStock = resolveOutOfStockState();

                // Only hide if product is in stock (button shouldn't be visible)
                if (!isOutOfStock) {
                  hideNotifyButtonImmediately(node);
                }
                // Reset retry count since button was found
                notifyButtonRetryCount = 0;
                scheduleNotifyUpdate();
              } else if (node.querySelector && node.querySelector('#pw_notify_popup_open')) {
                // Hide immediately if button is inside added node
                const button = node.querySelector('#pw_notify_popup_open');
                if (button) {
                  // #region agent log
                  sendDebugLog({ location: 'product-custom.js:309', message: 'MutationObserver: notify button found in added node', data: { parentNodeId: node.id, buttonId: button.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' });
                  // #endregion
                  // Check stock status BEFORE hiding - only hide if in stock
                  const isOutOfStock = resolveOutOfStockState();

                  // Only hide if product is in stock (button shouldn't be visible)
                  if (!isOutOfStock) {
                    hideNotifyButtonImmediately(button);
                  }
                  // Reset retry count since button was found
                  notifyButtonRetryCount = 0;
                }
                scheduleNotifyUpdate();
              }
            }
          });
        }
      });
    });

    // Start observing the document body for changes
    if (document.body) {
      notifyButtonObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    (function scheduleNotifyWhenProductFormReady() {
      var attempts = 0;
      var iv = setInterval(function () {
        var ready = document.querySelector("wetheme-product-form.product-form--ready");
        if (ready || ++attempts > 120) {
          clearInterval(iv);
          scheduleNotifyUpdateImmediate();
          setTimeout(scheduleNotifyUpdate, 200);
        }
      }, 50);
    })();

    window.addEventListener("load", function () {
      scheduleNotifyUpdate();
    });

    if (!swatchWrappergrp) {
      // Even if no swatch wrapper, still check initial state
      setTimeout(scheduleNotifyUpdate, 1000);
      return;
    }

    // Check if popup exists at page load
    // #region agent log
    setTimeout(function () {
      const popup = document.getElementById('mypw_model_popup');
      sendDebugLog({ location: 'product-custom.js:344', message: 'Popup existence check on page load', data: { popupExists: !!popup, popupId: popup?.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run2', hypothesisId: 'I' });
    }, 2000);
    // #endregion

    setTimeout(scheduleNotifyUpdate, 1000);
    setTimeout(scheduleNotifyUpdate, 3000);

      allSku.forEach((s) => s.classList.remove("current-sku"));
      allSkuname.forEach((s) => s.classList.add("hidden-skuname"));

      document
        .querySelector(`.active-sku--${swatchWrappergrp.dataset.varinatsku}`)
        .classList.add("current-sku");
      document
        .querySelector(`.active-sku--name--${swatchWrappergrp.dataset.varinatsku}`)
        .classList.remove("hidden-skuname");

    swatchWrapper.addEventListener("click", function (e) {
      let currentSwatch = e.target.closest(".swatch-element input");
      let currentSwatchEle = e.target.closest(".swatch-element");
      // #region agent log
      sendDebugLog({ location: 'product-custom.js:356', message: 'Swatch clicked', data: { swatchClasses: currentSwatchEle?.className, isSoldout: currentSwatchEle?.classList.contains("soldout"), isAvailable: currentSwatchEle?.classList.contains("available") }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'E' });
      // #endregion
      if (!currentSwatchEle) return;

      scheduleNotifyCheckAfterVariantChange();

      if (!currentSwatch) return;
      allSku.forEach((s) => s.classList.remove("current-sku"));
      allSkuname.forEach((s) => s.classList.add("hidden-skuname"));

      document
        .querySelector(`.active-sku--${currentSwatch.dataset.varinatsku}`)
        .classList.add("current-sku");
      document
        .querySelector(`.active-sku--name--${currentSwatch.dataset.varinatsku}`)
        .classList.remove("hidden-skuname");

      document
        .querySelector(`.active-sku--${currentSwatch.dataset.varinatsku}`)
        .classList.add("current-sku");
      document
        .querySelector(`.active-sku--name--${currentSwatch.dataset.varinatsku}`)
        .classList.remove("hidden-skuname");

      // Check SKU disclaimer when swatch changes
      if (currentSwatch.dataset.varinatsku) {
        checkSkuDisclaimer(currentSwatch.dataset.varinatsku);
      }
    });

    const skudisclaimer = [
      "270226",
      "270222",
      "271242",
      "270542",
      "271215",
      "271340",
      "270515",
      "270005",
      "271213",
      "270513",
      "270003",
      "271216",
      "270516",
      "272016",
      "271217",
      "271218",
      "270517",
      "273017",
      "272017",
      "270518",
      "272018",
      "265010",
      "271674",
      "260523",
      "270735",
      "270725",
      "270745",
      "270216",
      "270215",
      "270266",
      "270271",
      "390335",
      "969329",
      "2204159",
      "270256",
      "270238",
      "270246",
      "352777",
      "161012",
      "160516",
      "270005",
      "274040",
    ];
    const checkBox = document.querySelector(".checkbox-wrapper");

    // Function to check SKU disclaimer
    function checkSkuDisclaimer(skuValue) {
      if (!checkBox) {
        console.log('Checkbox wrapper not found for SKU disclaimer');
        return;
      }

      if (skudisclaimer.includes(skuValue)) {
        checkBox.style.display = "block";
      } else {
        checkBox.style.display = "none";
      }
    }

    // Check initial SKU on page load
    if (swatchWrappergrp && swatchWrappergrp.dataset.varinatsku) {
      checkSkuDisclaimer(swatchWrappergrp.dataset.varinatsku);
    }

    let pailProduct = document.querySelector(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"]'
    );
    let input = document.querySelector(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
    );

    if (pailProduct) {
      pailProduct.querySelector("input").value = 2;
    }

    pailProduct?.addEventListener("click", function (e) {
      let minus = e.target.closest(
        '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--minus'
      );
      if (!minus) return;
      pailProduct.querySelector("input").value =
        Number(pailProduct.querySelector("input").value) != 2
          ? Number(pailProduct.querySelector("input").value) - 2
          : 2;
    });

    pailProduct?.addEventListener("click", function (e) {
      let plus = e.target.closest(
        '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--plus'
      );
      if (!plus) return;
      let inputBox = pailProduct.querySelector(
        '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
      );
      inputBox.value = Number(inputBox.value) + 2;
    });

    input?.addEventListener("change", function () {
      let evenNo = convertToEvenNumber(this.value * 1);
      if (evenNo < 0) {
        this.value = evenNo;
      } else {
        this.value = 2;
      }
    });

    const convertToEvenNumber = function (no) {
      let evenNo = no % 2 != 0 ? no + 1 : no;
      return evenNo;
    };
  });

  document.addEventListener('DOMContentLoaded', function () {
    const popupOpens = document.querySelectorAll('#pw_notify_popup_open, #pw_notify_popup_open_sticky');
    popupOpens.forEach(function(popupOpen) {
      popupOpen.addEventListener('click', function (e) {
        e.preventDefault();
        // Don't stopPropagation - app may use event delegation to create/show popup
        let popup = document.getElementById('mypw_model_popup');
        if (!popup) {
          const iframes = document.querySelectorAll('iframe');
          for (let i = 0; i < iframes.length; i++) {
            try {
              const doc = iframes[i].contentDocument;
              if (doc && (popup = doc.getElementById('mypw_model_popup'))) break;
            } catch (_) {}
          }
        }
        if (!popup) popup = document.getElementById('pw_model_popup') || document.querySelector('[id*="pw_model_popup"]');
        if (popup) {
          popup.style.display = 'flex';
          popup.style.visibility = 'visible';
        } else {
          setTimeout(function () {
            const retryPopup = document.getElementById('mypw_model_popup') || document.getElementById('pw_model_popup');
            if (retryPopup) {
              retryPopup.style.display = 'flex';
              retryPopup.style.visibility = 'visible';
            }
          }, 100);
        }
      });
    });
  });

